var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 56,
    viewBox: "0 0 65 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1052 33.9877C28.1052 36.1368 29.8536 37.8851 32.0026 37.8851C34.1517 37.8851 35.9 36.1368 35.9 33.9877C35.9 32.3523 33.9256 21.992 32.0026 12.413C30.0796 21.992 28.1052 32.3525 28.1052 33.9877Z",
    fill: "#5495C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7009 8.04514L19.5523 16.8965C22.4847 14.4756 26.1314 12.8913 30.1237 12.5096V0C22.89 0.415137 16.1095 3.22379 10.7009 8.04514Z",
    fill: "#5495C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9605 10.7017L47.1091 19.553C49.5301 22.4854 51.1144 26.1321 51.4961 30.1244H64.0057C63.5904 22.8908 60.7819 16.1102 55.9605 10.7017Z",
    fill: "#5495C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8816 0V12.5096C37.8739 12.8913 41.5206 14.4756 44.453 16.8965L53.3043 8.04514C47.8958 3.22379 41.1152 0.415137 33.8816 0Z",
    fill: "#5495C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8508 45.8506L44.5225 47.1788L53.3436 55.9999L54.6718 54.6717C60.282 49.0615 63.5547 41.7379 64.0057 33.8811H51.4976C51.0702 38.4029 49.1034 42.5981 45.8508 45.8506Z",
    fill: "#5495C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.1244H12.5096C12.8913 26.1321 14.4756 22.4854 16.8965 19.553L8.04514 10.7017C3.22379 16.1102 0.415262 22.8908 0 30.1244H0Z",
    fill: "#5495C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33388 54.6718L10.6621 56L19.4833 47.1789L18.1549 45.8507C14.9023 42.5983 12.9355 38.4031 12.508 33.8813H0C0.450953 41.7381 3.72371 49.0616 9.33388 54.6718Z",
    fill: "#5495C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.89e22425.svg";
export { ForwardRef as ReactComponent };